import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {MailThreadComponent} from './components/mail-thread/mail-thread.component';
import {EmailThreadContainerComponent} from '@features/inbox/components/email-thread-container/email-thread-container.component';
import {PlatformDialogDefinitionEmailThreadEditorComponent} from '@features/inbox/editors/platform-dialog-definition-email-thread-editor/platform-dialog-definition-email-thread-editor.component';
import {PlatformMailCardViewerComponent} from '@features/inbox/components/cell-components/platform-mail-card-viewer/platform-mail-card-viewer.component';
import {InboxComponent} from '@features/inbox/components/inbox/inbox.component';
// @dynamic
export class InboxDynamicComponentHelper {
  static components: any;

  static create (): void {
  }

  public static init () {
    if (InboxDynamicComponentHelper.components) {
      return;
    }
    const components = {};
    components['MailDetailContentComponent'] = MailThreadComponent;
    components['EmailThreadContainerComponent'] = EmailThreadContainerComponent;
    components['PlatformDialogDefinitionEmailThreadEditorComponent'] = PlatformDialogDefinitionEmailThreadEditorComponent;
    components['PlatformMailCardViewerComponent'] = PlatformMailCardViewerComponent;
    components['InboxComponent'] = InboxComponent;
    InboxDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }

  public static getComponentArray (): any[] {
    InboxDynamicComponentHelper.init();
    const componentArray = [];
    Object.keys(InboxDynamicComponentHelper.components).forEach(key => {
      componentArray.push(InboxDynamicComponentHelper.components[key]);
    });
    return componentArray;
  }
  public static register(key: string, component: any) {
    InboxDynamicComponentHelper.components[key] = component;
    RootDynamicComponentHelper.register(key, component);
  }
}
